import { Alert, AlertDescription, AlertIcon } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";

export const AnonymizationBanner = ({ sharedWith }: { sharedWith: "tenderers" | "dialogueParticipants" }) => {
  const { t } = useTranslation();
  return (
    <Alert status="warning" rounded="md" fontSize="sm" alignItems="flex-start">
      <AlertIcon />
      <AlertDescription>
        {sharedWith === "dialogueParticipants"
          ? t(
              "Equal treatment: anonymize the supplier and remove identifying details before you share the answer with all participants."
            )
          : t(
              "Equal treatment: anonymize the supplier and remove identifying details before publishing to all tenderers."
            )}
      </AlertDescription>
    </Alert>
  );
};
